import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { ReportsBasePage } from '../reportsBase/reportsBase.page';
import type { TReportType } from '@shared/models';

@Component({
    'selector': 'app-report1TypePage',
    'templateUrl': './report1Type.page.html',
    'styleUrls': ['./report1Type.page.scss'],
    'standalone': true,
    'imports': [IonicModule, CommonModule, FormsModule]
})
export class Report1TypePage extends ReportsBasePage implements OnInit, OnDestroy {
    // private vm = {};
    public summaryReports: TReportType[] = [
        {
            // Add columns:  NumberOfTicketsCreated, NumberOfTicketsCompleted.  Look at ticketDetail
            'title': 'Tickets Summary Report',
            'description': 'Number of tickets created by service advisor per day.',
            'name': 'ticketSummary',
            'columns': ['Ticket Creation Date', 'Number of Tickets', 'Service Advisor'],
            'colWidths': [220, 180, 200],
            'reportParmsNeeded': true
        },
        {
            'title': 'Trips Summary Report',
            'description': 'Number of trips per day.',
            'name': 'tripSummary',
            'columns': ['Trip Completed Date', 'Number of Trips', 'Driver'],
            'colWidths': [220, 200, 400, 150],
            'reportParmsNeeded': true
        },
        {
            'title': 'Campaign Summary Report',
            'description': 'Number of incentives sent per campaign.',
            'name': 'campaignSummary',
            'columns': ['Campaign Date', 'Num Recipients'],
            'colWidths': [210, 150],
            'reportParmsNeeded': true
        },
        {
            'title': 'Customer Summary Report',
            'description': 'Number of customers acquired per day.',
            'name': 'customerSummary',
            'columns': ['Date', 'Customers Acquired'],
            'sortColumns': [0],
            'colWidths': [210, 1100],
            'reportParmsNeeded': true
        },
        {
            'title': 'Dashboard Summary Report',
            'description': 'Overall statistics of the dealership.',
            'name': 'dashboardSummary',
            'columns': ['Category ', 'Count'],
            'colWidths': [320, 600],
            'reportParmsNeeded': false
        },
    ];

    public detailReports: TReportType[] = [
        {
            'title': 'Ticket Detail Report',
            'description': 'Ticket details processed per day.',
            'name': 'ticketDetail',
            'columns': ['Created Date', 'Completed Date', 'Duration', 'Location', 'Service Advisor', 'Driver'],
            'colWidths': [150, 150, 150, 200, 200, 200],
            'reportParmsNeeded': true
        },
        {
            'title': 'Passenger Timing Detail Report',
            'description': 'Passenger wait times.',
            'name': 'passengerDetail',
            'columns': ['Created Date', 'Assigned', 'Enroute', 'Current', 'Completed', 'Passenger', 'Destination', 'Driver'],
            'colWidths': [150, 150, 150, 150, 150, 150, 150, 150],
            'reportParmsNeeded': true
        },
        {
            'title': 'SMS Detail Report',
            'description': 'SMS message specifics.',
            'name': 'smsDetail',
            'columns': ['Sent Date', 'Sent Time', 'Customer Name', 'Cell Phone', 'Type', 'Text Message'],
            'colWidths': [150, 150, 150, 200, 200, 200],
            'reportParmsNeeded': true
        },
    ];

    public settingsReports: TReportType[] = [
        {
            'title': 'Account Profile Report',
            'description': 'View the current details of your account.',
            'name': 'accountProfile',
            'columns': ['Property', 'Value'],
            'colWidths': [340, 600],
            'reportParmsNeeded': false
        },
        {
            'title': 'Dealership Report',
            'description': 'View dealership properties.',
            'name': 'dealership',
            'columns': ['Property', 'Value'],
            'colWidths': [270, 600],
            'reportParmsNeeded': false
        },
        {
            'title': 'Users Report',
            'description': 'View who has access to your account.',
            'name': 'users',
            'columns': ['Name', 'Role', 'Cell Phone', 'Email'],
            'colWidths': [220, 200, 200, 320],
            'reportParmsNeeded': false
        },
        {
            'title': 'Shuttles Report',
            'description': 'View which shuttles are configured.',
            'name': 'shuttles',
            'columns': ['Shuttle Name', 'Status', 'Capacity', 'Color', 'Description'],
            'colWidths': [170, 150, 120, 140, 500],
            'reportParmsNeeded': false
        },
        {
            'title': 'Service Areas Report',
            'description': 'View which areas your shuttles service.',
            'name': 'serviceAreas',
            'columns': ['Zipcode', 'Distance', 'City'],
            'colWidths': [150, 170, 310],
            'reportParmsNeeded': false
        }
    ];

    constructor( injector: Injector) {
        super(injector);
        // this.vm = {};
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_REPORTS);
    }

    public override ngOnInit(): void {
        super.ngOnInit();

        this.vm.isDebugMode = this.sessionService.isDebugMode();
        // this.initMoreMenu();
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    // public initMoreMenu(): void {
    //     this.resetPopoverMenu();
    //     this.pushPopoverMenuItem('Show Tour', 'show-reports-tour');
    // }

    public onNextClick() {
        if (this.vm.selectedReport) {
            super.setViewModel(this.vm);
            if (this.vm.selectedReport.reportParmsNeeded) {
                // this.router.navigateByUrl('/about/privacyPolicy');

                // this.router.navigateByUrl('/reports/reportPage1/reportPage2');
                this.router.navigateByUrl('/reports/report2Parameters');
            } else {
                this.router.navigateByUrl('/reports/report3View');
            }
        }
    }

    public onChooseReportClick(report) {
        this.vm.selectedReport = report;
    }
}
